module.exports = __webpack_public_path__ + "public/images/foreign-language.202eebea528b968e7a0ee344c3a38254.png";